import Select from "react-select";
import {useQuery} from "react-query";
import React, {useEffect, useState} from "react";
import {SelectOptionType} from "Model/Select/SelectOption";
import {getAnnualIncome} from "../../Api/Query/TutorQuery";

interface Props {
    onChange: (newValue: SelectOptionType|null) => void,
    onLoad?: (activities: any[]) => void,
    value?: any,
    classes?: string,
    filters?: {[key:string]:string|number}
}

export const AnnualIncomeSelect : React.FC<Props> = (props) => {

    const [options, setOptions] = useState<any>([])

    const query = useQuery({
        enabled: false,
        queryKey: ['getAnnualIncome'],
        queryFn: () => getAnnualIncome({size:0, sort:'position'}),
        onSuccess: (response: any) => {
            const items : object[] = []
            response.data._result.items.map((item:any) => {
                items.push({
                    label: item.name,
                    value: item.id
                })
            })
            setOptions(items)

            if(props.onLoad){
                props.onLoad(response.data._result.items)
            }
        },
        onError: (error: any) => {

        }
    })

    useEffect(() => {
        query.refetch()
    }, [])

    return (
        <Select
            // isLoading={isLoading}
            value={props.value ?? null}
            options={options}
            placeholder={""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={props.onChange}
            className={props.classes ?? ''}
        />
    )
}
